import axios from "axios";
import { safeGet } from "../../utils/safeStorage";

const baseURL = `${process.env.REACT_APP_DOMAIN_URL}/api`;

const api = () =>
  axios.create({
    baseURL,
    timeout: 15000,
    headers: {
      Authorization: `Bearer ${safeGet("nd-rest-tkn")}`,
      "Content-Type": "application/json",
    },
  });

export const fetchMyClass = async () => {
  try {
    const res = await api().get("/me/class");
    return res.data?.class ?? null;
  } catch {
    return null;
  }
};

export const fetchMyMakeupClass = async () => {
  try {
    const res = await api().get("/me/makeup-class");
    return res.data?.makeup_class ?? null;
  } catch {
    return null;
  }
};

export const markAttendance = async (scheduleId) => {
  try {
    const res = await api().post(`/schedules/${scheduleId}/attend`);
    return { ok: true, data: res.data };
  } catch (err) {
    return { ok: false, message: err?.response?.data?.message || "Something went wrong." };
  }
};

export const getMaterialUrl = (scheduleId) =>
  `${process.env.REACT_APP_DOMAIN_URL}/api/schedules/${scheduleId}/download-material`;
